import _ from "lodash";
import React from "react";
import moment from "moment";
import {
  LearningExperienceColored,
  SummativeAssessmentColored,
  FormativeAssessmentColored,
  QuickTaskOutlined,
  AiOutlined,
} from "@toddle-edu/ds-icons";
import { colors } from "Constants";
import { CreateAssessmentSvg, QuickTaskFilledIcon } from "SvgComponents";

export const ASSIGNMENT_TYPE_MAPPING = {
  le: {
    iconElement: <LearningExperienceColored size={"xx-small"} />,
  },
  ASSESSMENT: {
    iconElement: <LearningExperienceColored size={"xx-small"} />,
  },
  ASSIGNMENT_RESOURCE: {
    iconElement: <QuickTaskOutlined size={"xx-small"} variant={"link"} />,
  },
  qt: {
    iconElement: <QuickTaskOutlined size={"xx-small"} variant={"link"} />,
  },
  smt: {
    iconElement: <SummativeAssessmentColored size={"xx-small"} />,
  },
  fmt: {
    iconElement: <FormativeAssessmentColored size={"xx-small"} />,
  },
  pt: {
    iconElement: (
      <CreateAssessmentSvg fill={colors.white} fill1={colors.blue400} />
    ),
  },
  pri: {
    iconElement: (
      <CreateAssessmentSvg fill={colors.white} fill1={colors.blue400} />
    ),
  },
  se: {
    iconElement: (
      <CreateAssessmentSvg fill={colors.white} fill1={colors.blue400} />
    ),
  },
  dp_pa: {
    iconElement: (
      <QuickTaskFilledIcon fill={colors.white} fill1={colors.blue400} />
    ),
  },
  dp_ep: {
    iconElement: (
      <QuickTaskFilledIcon fill={colors.white} fill1={colors.blue400} />
    ),
  },
  worksheet: {
    iconElement: (
      <QuickTaskFilledIcon fill={colors.white} fill1={colors.blue400} />
    ),
  },
  ai_tutor: {
    iconElement: <AiOutlined size={"xx-small"} />,
  },
};

const getAssignmentsFromEdges = ({ data, t, currentAssessmentTypes }) => {
  return _.map(data, assignment => {
    const { id, content, contentType, createdAt } = _.get(
      assignment,
      "node",
      {}
    );

    const isQuickTask = contentType === "ASSIGNMENT_RESOURCE";

    let type = _.get(content, "assessmentType.value", "");

    type = type ? type : contentType;

    const title = isQuickTask
      ? { value: _.get(content, "quickTaskTitle") }
      : _.get(content, "title", "Untitled");

    const date = moment(createdAt).format("DD MMMM YYYY");
    const { localeLabel = "", label } = currentAssessmentTypes[type] ?? {};
    const subTitle = `${t(localeLabel, { defaultValue: label })} | ${date}`;

    const image = _.get(content, "image", {});

    return {
      id,
      title,
      subTitle,
      image,
      type,
      date,
    };
  });
};

export const getAssignmentsFromEdgesMemoized = _.memoize(
  getAssignmentsFromEdges,
  ({ data }) => {
    return JSON.stringify({
      data: _.map(data, ({ node }) => ({
        node: {
          id: node?.id,
          content: {
            id: node?.content?.id,
            title: _.pick(node?.content?.title, ["id", "value"]),
            image: _.pick(node?.content?.image, ["id", "value"]),
          },
        },
      })),
    });
  }
);
